import { useNavigate } from "react-router-dom";
import { Mail, Info, History } from "lucide-react";
import { useTickets } from "@/context/TicketContext";
import { IssueBadge } from "@/components/IssueBadge";

export const SubscriberRow = ({ subscriber }) => {
  const navigate = useNavigate();
  const { getTicketsForSubscriber, getClosedTicketsForSubscriber, getTicketedDeviceIds } = useTickets();
  
  const subscriberTickets = getTicketsForSubscriber(subscriber.id);
  const closedTickets = getClosedTicketsForSubscriber(subscriber.id);
  const activeTicketCount = subscriberTickets.length;
  const needAttentionCount = Math.max(0, subscriber.needAttention - subscriberTickets.length);
  
  const getTrendIcon = (trend) => {
    if (trend === 'up') return '\u2197';
    if (trend === 'down') return '\u2198';
    return '\u2014';
  };

  const handleNeedAttentionClick = () => {
    navigate(`/subscriber/${subscriber.id}/devices`);
  };

  const handleActiveTicketsClick = () => {
    navigate(`/subscriber/${subscriber.id}/tickets`);
  };

  const handleHistoryClick = () => {
    navigate(`/subscriber/${subscriber.id}/history`);
  };

  return (
    <tr data-testid={`subscriber-row-${subscriber.id}`}>
      <td>
        <span className="subscriber-name">{subscriber.name}</span>
      </td>
      <td>
        <span className="total-aeds">{subscriber.totalAeds}</span>
      </td>
      <td>
        <div className="issues-cell">
          <span className={`issues-count ${subscriber.issues > 5 ? 'red' : 'yellow'}`}>
            {subscriber.issues}
          </span>
          <span className={`issues-trend ${subscriber.trend}`}>
            {getTrendIcon(subscriber.trend)}
          </span>
        </div>
      </td>
      <td>
        <div className="issue-badges">
          {subscriber.issueTypes.map((issue, idx) => (
            <IssueBadge key={idx} type={issue.type} count={issue.count} />
          ))}
        </div>
      </td>
      <td>
        <div className="table-actions">
          <button 
            className="table-btn send" 
            data-testid={`need-attention-btn-${subscriber.id}`}
            onClick={handleNeedAttentionClick}
          >
            <Mail size={12} />
            Need Attention ({needAttentionCount})
          </button>
          <button 
            className="table-btn details" 
            data-testid={`active-tickets-btn-${subscriber.id}`}
            onClick={handleActiveTicketsClick}
          >
            <Info size={12} />
            Active Tickets ({activeTicketCount})
          </button>
          <button 
            className="table-btn history" 
            data-testid={`history-btn-${subscriber.id}`}
            onClick={handleHistoryClick}
          >
            <History size={12} />
            HISTORY ({closedTickets.length})
          </button>
        </div>
      </td>
    </tr>
  );
};
